import React from 'react';
import Children from '../../interfaces/children.interface';
import Icon from '../icon/icon.component';

export interface Props extends Children {
  /** The badges type determines the color and icon (defaults to 'warning') */
  type?: 'notice' | 'info' | 'warning' | 'error' | 'success';
  /** The position the badge is rendered at. */
  position?: 'top-right' | 'bottom-left';
}

/** Generate a random string */
const randomId = (): string =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, 5);

/** Renders a small badge in the (upper right) corner to notify the user */
const Badge = ({
  children,
  type = 'warning',
  position = 'top-right',
}: Props): React.ReactElement => {
  const id = `badge-${randomId()}`;
  return (
    <>
      <label htmlFor={id} className={`badge__badge badge--${type} badge--${position}`}>
        <Icon name={type} size="xs" variant="plain" />
      </label>
      <input id={id} type="checkbox" className="badge__checkbox" />
      <div className={`badge__content badge--${type} badge--${position}`}>{children}</div>
    </>
  );
};

export default Badge;
